import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm, change as changeFieldValue } from "redux-form";
import { FormattedMessage } from "react-intl";
import moment from "moment";
import _ from "lodash";

import { PasswordInput, SelectInput } from "../form";

import validationUtils from "../../../utils/ValidationUtils";
import { CONFIGURATIONS_FORM_VALIDATION_RULES } from "./ConfigurationsFormValidationRules";
import { CONFIGURATIONS, USERS } from "../../../utils/data/models";
import { INFORMATION_AGENT, PLAN_ADMINISTRATOR } from "../../../utils/Roles";
import * as dataActions from "../../../utils/data/dataActions";

const MOCK_AUTHORIZATION_CODE = new Array(20).join("x");

class ConfigurationsForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleAuthorizationCodeChange = this.handleAuthorizationCodeChange.bind(
      this
    );
    this.setAuthorizationCode = this.setAuthorizationCode.bind(this);
  }

  componentWillMount() {
    this.props.dataActions.getDataList(
      CONFIGURATIONS,
      0,
      0,
      "",
      ["configurationId:asc"],
      [CONFIGURATIONS.archiveFilter]
    );
    this.props.changeFieldValue(
      "configurations",
      "authorizationCode",
      MOCK_AUTHORIZATION_CODE
    );
    if (!this.props.users.length) {
      this.props.dataActions.getDataList(
        USERS,
        0,
        0,
        "",
        ["username:asc"],
        [USERS.archiveFilter]
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (
      !prevProps.configurations.fetched &&
      this.props.configurations.fetched
    ) {
      this.props.changeFieldValue(
        "configurations",
        "newMemberApprovalUserId",
        this.props.configurations.newMemberApprovalUserId
      );
    }
  }

  componentWillUnmount() {
    this.props.dataActions.clearDataList(USERS);
  }

  setAuthorizationCode(value) {
    this.props.changeFieldValue(
      "configurations",
      "isAuthorizationCodeSet",
      value
    );
  }

  handleAuthorizationCodeChange() {
    return (value) => {
      if (value != "" && value != MOCK_AUTHORIZATION_CODE) {
        this.setAuthorizationCode(true);
      } else {
        this.setAuthorizationCode(false);
      }
      return value;
    };
  }

  render() {
    const { configurations } = this.props;
    return (
      <form onSubmit={this.props.handleSubmit}>
        <Field
          id="authorizationCode"
          name="authorizationCode"
          component={PasswordInput}
          type="password"
          mockPassword={MOCK_AUTHORIZATION_CODE || ""}
          label={<FormattedMessage id="configurationsForm.authorizationCode" />}
          normalize={this.handleAuthorizationCodeChange(
            "isAuthorizationCodeSet"
          )}
        />
        <Field
          id="isAuthorizationCodeSet"
          name="isAuthorizationCodeSet"
          component="input"
          type="hidden"
        />
        <p className="last-modification">
          {configurations.fetched && (
            <FormattedMessage
              id="configurationsForm.lastModification"
              values={{
                modifiedOn: moment(configurations.updatedAt).toDate(),
                modifiedBy: `${configurations.lastModifiedByUser.firstName} ${configurations.lastModifiedByUser.lastName}`,
              }}
            />
          )}
        </p>
        <Field
          addBlankOption={true}
          blankMessageKey="common.blank"
          component={SelectInput}
          id="newMemberApprovalUserId"
          label={
            <FormattedMessage id="configurationsForm.newMemberApprovalUser" />
          }
          name="newMemberApprovalUserId"
          options={this.props.users.map((user) => ({
            value: user.userId,
            text: user.firstName + " " + user.lastName,
          }))}
        />
      </form>
    );
  }
}

ConfigurationsForm.propTypes = {
  configurations: PropTypes.object,
  dataActions: PropTypes.object,
  changeFieldValue: PropTypes.func,
  initialValues: PropTypes.object,
  handleSubmit: PropTypes.func,
  users: PropTypes.array,
};

function mapStateToProps(state) {
  const allUsers = _.get(state, "data.users.items") || [];
  return {
    configurations: state.data.configurations || {},
    users: allUsers.filter(
      (user) =>
        user.roleId !== INFORMATION_AGENT.roleId &&
        user.roleId !== PLAN_ADMINISTRATOR.roleId
    ),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  withRef: true,
})(
  reduxForm({
    form: "configurations",
    validate: (values) =>
      validationUtils.validate(values, CONFIGURATIONS_FORM_VALIDATION_RULES),
  })(ConfigurationsForm)
);



// WEBPACK FOOTER //
// ./src/components/common/Configurations/ConfigurationsForm.js